import verticalSeparator from './verticalSeparator'

export default (member: TMember): string =>
    `Living in ${member.residency.city ? `${member.residency.city} ${verticalSeparator} ` : ''}${
        member.residency.country.name
    }`
